import React from 'react';
import PropTypes from 'prop-types';
import { FDTextButton } from '@facet-wealth/design';

export const Cancel = ({ value, cancel }) => {
  if (!value) return null;

  return (
    <FDTextButton
      onClick={cancel}
      label={value}
      alignSelf="center"
    />
  );
};

Cancel.defaultProps = {
  cancel: () => {}, // Should never be used, but is here as a last resort to avoid blowing up in prod
};

Cancel.propTypes = {
  value: PropTypes.string.isRequired,
  cancel: PropTypes.func,
};
